import { css, cx } from "@emotion/css";
import Link from "next/link";
import { ValuePx, ValuePxLow, ValueRem, ValueVh, ValueVw } from "./Value";

const LayoutContainer: React.FC<{
  // Contents
  children: React.ReactElement | string;

  // Interactivity
  to?: string;
  onClick?: () => void;

  // Styling
  className?: Parameters<typeof cx>[0];
  colors?: [string, string] | [[string, string], [string, string]];
  center?: true;
  padding?:
    | ValueRem
    | `${ValueRem | ValueVh} ${ValueRem | ValueVw | ValuePxLow}`;
  maxWidth?: ValuePx | ValueRem;
}> = (props) => {
  if (props.padding != null && props.maxWidth != null) {
    let { maxWidth, children, ...rest } = props;

    return (
      <LayoutContainer {...rest}>
        <LayoutContainer {...{ maxWidth, children }} />
      </LayoutContainer>
    );
  }

  let colorsStyle;
  if (props.colors == null) {
    colorsStyle = css``;
  } else if (typeof props.colors[0] === "string") {
    colorsStyle = css`
      background-color: ${props.colors[0]};
      color: ${props.colors[1]};
    `;
  } else {
    colorsStyle = css`
      background-color: ${props.colors[0][0]};
      color: ${props.colors[0][1]};

      @media (prefers-color-scheme: dark) {
        background-color: ${props.colors[1][0]};
        color: ${props.colors[1][1]};
      }
    `;
  }

  const elementProps = {
    className: cx(
      css`
        label: LayoutContainer;
        display: block;
        box-sizing: border-box;
        padding: ${props.padding};
        align-self: ${props.center ? "center" : undefined};
        max-width: ${props.maxWidth};
        width: ${props.maxWidth ? "100%" : undefined};
        margin: ${props.maxWidth ? "0 auto" : undefined};

        ${colorsStyle}
        cursor: ${props.to != null || props.onClick != null
          ? "pointer"
          : undefined};
      `,
      props.className,
    ),
    children: props.children,
    onClick: props.onClick,
  };

  if (props.to == null) {
    return <div {...elementProps} />;
  } else {
    return <Link href={props.to} {...elementProps} />;
  }
};

export default LayoutContainer;
